<template>
  <div>
    <section>
      <div class="left">
        <h2 v-translate>Nastavení šablony</h2>

          <p>
              <translate>Založeno</translate>
              : <span class="date" v-html="$_date_formatFull(entity.date_created)"></span></p>
          <p>
              <translate>Upraveno</translate>
              : <span class="date" v-html="$_date_formatFull(entity.date_updated)"></span></p>
          <p>
              <translate>Vytvořil</translate>
              : <span class="date">{{ entity.user_created }}</span></p>
          <p>
              <translate>Upravil</translate>
              : <span class="date">{{ entity.user_updated }}</span></p>
      </div>
      <div class="right">
        <div class="field_left">
          <text-input id="templateName"
                      v-model="entity.name"
                      :required="true"
                      ref="templatenameref"
                      :disabled="!$_updateActionAllowed"
          >
            <translate class="translate">Název šablony</translate>
          </text-input>
        </div>
        <div class="field_right">
          <select-box
              id="templateType"
              :required="true"
              v-model="messageTemplateTypeComputed"
              :options="messageTypeOptions"
              ref="templatetyperef"
              :disabled="!$_updateActionAllowed"
          >
            <translate class="translate">Typ oznámení</translate>
          </select-box>
        </div>

        <div class="field" checkboxes>
          <p class="field">
            <filter-checkbox
                id="templateForceConfirmation"
                name="templateForceConfirmation"
                :val="entity.force_confirmation"
                v-model="entity.force_confirmation"
                :disabled="!$_updateActionAllowed"
            >
              <translate class="translate">Vynucení potvrzení</translate>
            </filter-checkbox>
          </p>
        </div>

        <div v-if="!entity.force_confirmation"  class="field_left">
          <date-picker edit-time
                       id="templateTimeValidity"
                       date-format="d. m. yy"
                       attrKey="time_validity"
                       v-model="entity.time_validity"
                       :required="false"
                       @update-date="updateTimeValidityDate"
                       :disabled="!$_updateActionAllowed"
          > <translate key="templateTimeValidityTitle" class="translate">Platnost</translate>
          </date-picker>
        </div>

        <div v-if="entity.force_confirmation" class="field_right">
          <p class="field">
            <text-input id="templateTimer"
                        v-model="entity.timer"
                        :required="false"
                        ref="templatetimerref"
                        type="number"
                        :disabled="!$_updateActionAllowed"
            >
              <translate key="templateTimerTitle" class="translate">Časovač</translate>
              <span>
                    <translate key="templateTimerSubtitle" class="translate">(sec)</translate>
                    </span>
            </text-input>
          </p>
        </div>
      </div>
    </section>

    <section>
      <div class="left">
        <translation-language-select
            :languages="languagesToSelect"
            :existingLanguages="existingLanguages"
            :selectedLanguage="selectedLanguageId"
            :shouldLoadDefaultLanguage="shouldLoadDefaultLanguage"
            @selectLanguage="onSelectLanguage"
            @languagesSelectionChanged="onLanguagesSelectionChanged"
            ref="translationlanguageref"
        />
      </div>

      <div class="right">

        <div class="field">
          <text-input id="translationSubject"
                      v-model="translation.subject"
                      :required="true"
                      name="translationSubject"
                      ref="translationsubjectref"
                      maxLength="50"
                      :disabled="!$_updateActionAllowed"
          >
            <translate class="translate">Nadpis oznámení</translate>
          </text-input>
        </div>

        <p class="field">
          <text-input
              id="translationShortBody"
              name="translationShortBody"
              v-model="translation.short_body"
              :required="false"
              ref="translationshortbodyref"
              maxLength="255"
              :disabled="!$_updateActionAllowed"
          >
            <translate class="translate">Zkrácená verze oznámení</translate>
          </text-input>
        </p>

        <p class="field">
          <html-editor
              id="translationBody"
              name="translationBody"
              :custom-toolbar="customToolbar"
              :body="translation.body"
              :required="false"
              ref="translationbodyref"
              @newVal="translation.body = arguments[0]"
              :disabled="!$_updateActionAllowed"
          >
            <translate class="translate">Tělo oznámení</translate>
          </html-editor>
        </p>
      </div>
    </section>
  </div>
</template>

<script>
import TranslationLanguageSelect from "../languanges/TranslationLanguageSelect"
import HtmlEditor from "../../../common/HtmlEditor"
import types from "../../messages/mixins/types"

export default {
  name: "MessageTemplateBasicInfo",
  props: {
    entity: Object,
    shouldLoadDefaultLanguage: {
      type: Boolean,
      default: false
    }
  },
  mixins: [types],
  data() {
    return {
      selectedLanguageId: null,
      translation: {
        language: null,
        subject: null,
        short_body: null,
        body: null
      },
      customToolbar: [
        ["bold", "italic", "underline"],
        [{
          color: []
        }]
      ]
    }
  },
  created() {

  },
  components: {TranslationLanguageSelect, HtmlEditor},
  computed: {
    messageTemplateTypeComputed: {
      get() {
        return this.entity.type
      },
      set(newValue) {
        this.entity.type = newValue
      }
    },
    languagesToSelect() {
      let languages = {}
      let languagesToSelect = []
      Object.assign(languages, this.$language.available)
      for (let key in languages) {
        languagesToSelect.push({value: key.toLowerCase(), text: key})
      }
      return languagesToSelect
    },
    existingLanguages() {
      let existingLanguages = []
      for (let key in this.entity.translations) {
        existingLanguages.push({value: key.toLowerCase(), text: key})
      }
      return existingLanguages
    }
  },
  methods: {
    async onSelectLanguage(idLanguage) {
      this.saveCurrentTranslation()

      this.selectedLanguageId = idLanguage
      let tempTranslation = this.entity.translations[idLanguage]
      if (idLanguage !== null && tempTranslation !== null && tempTranslation) {
        this.translation.language = idLanguage
        this.translation.subject = tempTranslation.subject
        this.translation.short_body = tempTranslation.short_body
        this.translation.body = tempTranslation.body
      } else {
        this.translation.language = null
        this.translation.subject = ""
        this.translation.short_body = ""
        this.translation.body = ""
      }
    },
    onLanguagesSelectionChanged(newLanguagesSelection) {
      let translations = {}
      let foundCurrentlySelectedLanguage = false
      let firstLanguageId = null

      for (let key in newLanguagesSelection) {
        const lang = newLanguagesSelection[key].value

        if (firstLanguageId === null) {
          firstLanguageId = lang
        }

        if (lang === this.selectedLanguageId) {
          foundCurrentlySelectedLanguage = true
        }

        if (this.entity.translations.hasOwnProperty(lang)) {
          translations[lang] = this.entity.translations[lang]
        } else {
          translations[lang] = {body: "", subject: "", short_body: ""}
        }

      }

      if (!foundCurrentlySelectedLanguage) {
        this.onSelectLanguage(firstLanguageId)
      }

      this.entity.translations = translations
    },
    saveCurrentTranslation() {
      if (this.selectedLanguageId !== null) {
        this.entity.translations[this.selectedLanguageId] = {
          "subject": this.translation.subject,
          "short_body": this.translation.short_body,
          "body": this.translation.body
        }
        return this.translation
      }
    },
    updateTimeValidityDate(dateInfo) {
      this.entity.time_validity = dateInfo.date
    },
  }
  ,
  watch: {
    entity: {
      handler(newVal) {
        if (!newVal.force_confirmation) {
          this.entity.timer = null
        } else {
          this.entity.time_validity = null
        }

        if (newVal.translation !== null && this.selectedLanguageId === null) {
          let firstLanguage = null
          for (const key in this.entity.translations) {
            firstLanguage = key
            break
          }
          if (firstLanguage !== null) {
            this.onSelectLanguage(firstLanguage)
          }
        }
      }, deep: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/messagetemplates/settings/MessageTemplateBasicInfo.vue